
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/data-center-project-readiness-governance",
      function () {
        return require("private-next-pages/services/data-center-project-readiness-governance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/data-center-project-readiness-governance"])
      });
    }
  